import React, { useEffect, useState } from "react";
import styles from "./ProjectEndingFlow.module.css";
import { Card, Grid, Stack, Typography } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useLocation, useNavigate } from "react-router-dom";
import ImageAssets from "../../../assets";
import { MuiButton } from "../../../components/common/button/MuiButton";
import CustomizedDialog from "../../../components/common/dailog/customized-dialog/CustomizedDialog";
import { MuiRadioButton } from "../../../components/common/mui-radio-button/MuiRadioButton";
import { MuiTextArea } from "../../../components/common/mui-text-area/MuiTextArea";
import MuiStepper from "../../../components/common/stepper/MuiStepper";
import { EndProjectStepperEnumUtils } from "../../../core/enumerations/EndProjectStepperEnum";
import routesNames from "../../../routes/RouteNames";
import strings from "../../../strings/Strings";
import CustomAvatar from "../../../components/common/avatar/MuiAvatar";
import { MuiCheckbox } from "../../../components/common/checkbox/MuiCheckBox";
import { useDispatch, useSelector } from "react-redux";
import { dashboardRedux, rateProjectRequest } from "../../../redux/dashboard-redux/DashboardRedux";
import CustomSuccessDailog from "../../../components/common/dailog/success-dailog/MuiSuccessDailog";
import { CapitalizeString } from "../../../utils/CapitalizeString";

const ProjectEndingFlow = () => {

  const radioGroupData = [
    {
      id: 1,
      label: strings.yes,
    },
    {
      id: 2,
      label: strings.no,
    },
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const actionDispatch = (dispatch: any) => ({
    getAllCollaborators: (data: any) =>
      dispatch(dashboardRedux.actions.getAllCollaboratorsRequest(data)),

    setDashboardState: (data: any) =>
      dispatch(dashboardRedux.actions.setDashboardState(data)),

    endProject: (data: any) =>
      dispatch(dashboardRedux.actions.endProjectRequest(data)),
  });

  const { getAllCollaborators, setDashboardState, endProject } = actionDispatch(useDispatch());
  const dashboardState = useSelector((state: any) => state.dashboardRedux);

  const [activeStep, setActiveStep] = useState<number>(location?.state?.activeStep || 0);
  const [selectedArtistId, setSelectedArtistId] = useState()
  const [openShareExperienceDialog, setOpenShareExperienceDialog] =
    useState(false);
  const [openExperienceDialog, setOpenExperienceDialog] = useState(false);

  type RatingReview = {
    rating: number;
    review: string;
    userId: string;
  };

  const [projectMembers, setProjectMembers] = useState([]);
  const [ratingsAndReviews, setRatingsAndReviews] = useState<RatingReview[]>([]);

  const steps = EndProjectStepperEnumUtils.getEndProjectStepperEnums();

  // useEffect(() => {
  //   getAllCollaborators({ projectId: location?.state?.projectId })
  // }, [])

  useEffect(() => {
    if (dashboardState.isProjectEnded) {
      setDashboardState({
        key: "isProjectEnded",
        value: false
      })
      navigate(routesNames.home)
    }
  }, [dashboardState.isProjectEnded])

  const handleCheckboxChange = (rating: any) => {
    let array = ratingsAndReviews;
    let selectedData: any = array.find((item) => item?.userId === selectedArtistId);
    if (selectedData && selectedData?.userId) {
      let index = array.indexOf(selectedData);
      array.splice(index, 1, { ...selectedData, rating: rating })
    }
    else {
      array.push({
        rating: rating,
        review: '',
        userId: selectedArtistId,
      })
    }
    setRatingsAndReviews([...array]);
  }

  const handleStepClick = (index: number) => {
    if (activeStep !== 0) {
      setActiveStep(index);
    }
  };

  const handleRadioChange = (event: any) => {
    setDashboardState({
      key: "endProjectDetails",
      value: {
        ...dashboardState.endProjectDetails,
        isProjectCompleted: parseInt((event.target as HTMLInputElement).value)
      }
    })

  };

  const handleReviewChange = (event: any) => {
    const array = ratingsAndReviews;
    const newArray = array?.map((artistData: any) => artistData?.userId === selectedArtistId ?
      {
        ...artistData,
        review: event.target.value
      } : {
        ...artistData,
      })
    setRatingsAndReviews([...newArray]);
  }

  const handleRateMembers = () => {
    dispatch(rateProjectRequest({
      reqBody: ratingsAndReviews, projectId: location?.state?.projectId
    }));
    navigate(routesNames.home);
  }

  const handleEndProject = () => {
    const reqBody = {
      isProjectCompleted: dashboardState.endProjectDetails?.isProjectCompleted === 1 ? true : false,
      ratingsAndReviews: ratingsAndReviews
    }

    endProject({
      reqBody: reqBody, projectId: location?.state?.projectId
    })
  }

  const handleSubmit = () => {
    setOpenExperienceDialog(false);
    handleEndProject()
  }

  const handleSkipClick = () => {
    setOpenShareExperienceDialog(false);
    handleEndProject()
  }

  const handleProjectEndingButton = () => {
    if (activeStep === 0) {
      setActiveStep(1);
    } else if (activeStep === 1) {
      setOpenShareExperienceDialog(true);
    }
  };

  const onClickOnShareYourExperienceButton = () => {
    setOpenShareExperienceDialog(false);
    setOpenExperienceDialog(true);
  };

  const fetchAllMembers = async () => {
    const apiResponse = await fetch(`${process.env.REACT_APP_SEKERON_PROJECT_MANEGEMENT_URL}/project/${location?.state?.projectId}/all-members`,
      {
        method: 'Get',
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
    const response = await apiResponse.json();
    const data = response?.data;
    setSelectedArtistId(data.length > 0 && data[0]?.artist_id);
    const membersData = data.flat();
    setProjectMembers([...membersData]);
  }

  console.log(ratingsAndReviews, "ratingsAndReviews", projectMembers);

  useEffect(() => {
    fetchAllMembers();
  }, [])

  const renderConfirmationScreen = () => {
    return (
      <Stack rowGap={5} className={styles["project-ending-content"]}>
        <Typography className={styles["about-to-finish"]}>
          {strings.aboutToFinish}
        </Typography>
        <div className={styles["project-completed-container"]}>
          <Typography className={styles["project-completed"]}>
            {strings.isThisProjectCompleted}
          </Typography>
          <MuiRadioButton
            value={dashboardState?.endProjectDetails?.isProjectCompleted}
            handleChange={handleRadioChange}
            data={radioGroupData}
          />
        </div>
        <Typography className={styles["sugestion-message"]}>
          {strings.projectEndSuggestionMesssge}
        </Typography>
      </Stack>
    );
  };

  const renderRatingStar = () => {
    return [...Array(5)].map((option: any, index: number) => {
      index += 1;
      return (
        <MuiCheckbox
          uncheckedIcon={ImageAssets.ic_inactive_star}
          checkedicon={ImageAssets.ic_active_star}
          checked={index <= fetchRatingDetails()?.rating}
          onChange={() => handleCheckboxChange(index)}
        />
      )
    }
    );
  };

  const fetchUserDetails = () => {
    const data = projectMembers?.find((collaborator: any) => selectedArtistId === collaborator?.artist_id)
    return data
  }

  const fetchRatingDetails = () => {
    const data = ratingsAndReviews?.find((rate: any) => selectedArtistId === rate?.userId)
    return data
  }

  const renderRateCollabaratorScreen = () => {
    if (projectMembers?.length) {
      return (
        <div className={styles["rate-collabarator-container"]}>
          <Stack rowGap={{ xs: 1.5, sm: 1.5, md: 2 }} direction={"column"}>
            <Card className={styles["collabarator-card"]}>
              <Typography className={styles["rate-title"]}>
                {strings.rateColloborators}
              </Typography>
              <Stack rowGap={2} direction={"column"}>
                <div className={styles["collabarator-details"]}>
                  <CustomAvatar
                    numberOfAvatars={1}
                    imageAvatars={[{ id: 1, imageUrl: fetchUserDetails()?.profile_pic || ImageAssets.ic_default_profile_image }]}
                    variant={"circular"}
                    sx={{
                      width: { xs: "4rem", sm: "6rem" },
                      height: { xs: "4rem", sm: "6rem" },
                    }}
                  />

                  <div className={styles["details"]}>
                    <span
                      className={styles["name"]}
                      title={fetchUserDetails()?.user_name}
                    >
                      {fetchUserDetails()?.user_name}
                    </span>
                    <div>
                      <span className={styles["skill-in-web"]}>
                        {fetchUserDetails()?.skills?.length > 0 && fetchUserDetails()?.skills[0]}
                        {
                          fetchUserDetails()?.skills?.length > 1 &&
                          ` +${fetchUserDetails()?.skills?.length - 1}`
                        }
                      </span>
                    </div>
                  </div>
                </div>
                <Stack
                  direction={"row"}
                  columnGap={2}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  {renderRatingStar()}
                </Stack>
              </Stack>
              <Stack rowGap={2} className={styles["feedback-container"]}>
                <Typography className={styles["about-collabarator"]}>
                  {strings.colloboratorDescription}
                </Typography>
                <MuiTextArea
                  fullWidth
                  type="text"
                  maxLength={500}
                  name="description"
                  onChange={(event: any) => handleReviewChange(event)}
                  value={fetchRatingDetails()?.review || ''}
                  isShowSlider={true}
                  multiline
                  rows={4}
                  maxRows={4}
                  inputProps={{
                    "data-testid": "project-description",
                    maxLength: 500,
                  }}
                  label={strings.typeHere}
                  errorMessage=""
                />
              </Stack>
            </Card>
            <Card className={styles["collabarator-list-card"]}>
              <Grid
                container
                columns={12}
                className={styles["collabarator-liss-container"]}
              >
                {projectMembers?.length > 0 && projectMembers?.map((artistDetails: any, artistIndex: number) => {
                  return (
                    <Grid
                      key={artistIndex}
                      item
                      xs={6}
                      sm={6}
                      md={6}
                      lg={6}
                      xl={6}
                      padding={"15px"}
                      onClick={() => setSelectedArtistId(artistDetails?.artist_id)}
                      className={
                        styles[
                        fetchUserDetails()?.artist_id === artistDetails?.artist_id
                          ? "selected-profile"
                          : "un-selected-profile"
                        ]
                      }
                    >
                      <Stack columnGap={1} direction={"row"}>
                        <img
                          className={styles["profile"]}
                          alt={"profile-pictures"}
                          src={artistDetails?.profile_pic || ImageAssets.ic_default_profile_image}
                        />
                        <div className={styles["details"]}>
                          <span
                            className={styles["name"]}
                            title={artistDetails?.user_name}
                          >
                            {artistDetails?.user_name}
                          </span>
                          <div>
                            <span className={styles["skill-in-web"]}>
                              {artistDetails?.skills?.length > 0 && artistDetails?.skills[0]}
                              {
                                artistDetails?.skills?.length > 1 &&
                                ` +${artistDetails?.skills?.length - 1}`
                              }
                            </span>
                          </div>
                        </div>
                      </Stack>
                    </Grid>
                  );
                })}
              </Grid>
            </Card>
          </Stack>
        </div>
      );
    }
  };

  return (
    <Stack
      rowGap={{ xs: 1, sm: 2, md: 5 }}
      direction={"column"}
      className={styles["project-ending-container"]}
    >
      {openShareExperienceDialog ? (
        <CustomSuccessDailog
          open={openShareExperienceDialog}
          handleDailogClose={() => setOpenExperienceDialog(false)}
          successIcon={ImageAssets.ic_project_success_icon}
        >
          <Stack
            rowGap={5}
            direction={"column"}
            alignItems={"center"}
            className={styles["project-end-dialog"]}
          >
            <Typography className={styles["succes-text"]}>
              {CapitalizeString(location?.state?.projectName)}{" "}
              <span>has {strings.finishedSuccessfully}</span>
            </Typography>
            <MuiButton
              className={styles["clear-all"]}
              onClick={() => onClickOnShareYourExperienceButton()}
            >
              {strings.shareYourExperience}
            </MuiButton>
            <a
              onClick={handleSkipClick}
              className={styles["skip"]}
            >
              {strings.skip}
            </a>
          </Stack>
        </CustomSuccessDailog>
      ) : null}

      <CustomizedDialog
        handleCloseDialog={() => setOpenExperienceDialog(false)}
        open={openExperienceDialog}
      >
        <Stack
          rowGap={5}
          direction={"column"}
          alignItems={"center"}
          className={styles["project-end-dialog"]}
        >
          <div>
            <Typography className={styles["project-name"]}>
              {CapitalizeString(location?.state?.projectName)}
            </Typography>
            <Typography className={styles["experience-dialog"]}>
              {strings.howWasYourExperience}
            </Typography>
          </div>
          <MuiTextArea
            fullWidth
            type="text"
            maxLength={500}
            name="description"
            // onChange={(event: any) => handleChange(event)}
            // value={selectedArtist?.feedBack}
            isShowSlider={true}
            multiline
            rows={8}
            maxRows={8}
            isBorderNotNeeded={true}
            inputProps={{
              "data-testid": "project-description",
              maxLength: 500,
            }}
            placeholder={strings.writeToUs}
            errorMessage=""
          />
          <MuiButton
            className={styles["proceed"]}
            onClick={handleSubmit}
          >
            {strings.submit}
          </MuiButton>
        </Stack>
      </CustomizedDialog>

      <Stack columnGap={1} className={styles["mobile-header"]}>
        <ArrowBackIosNewIcon
          sx={{ color: "var(--secondary-lite-grey-color)", fontSize: "24px" }}
        />
        <span className={styles["finish-project"]}>
          {strings.finishProject}
        </span>
      </Stack>
      <Typography className={styles["title"]}>
        <span>{strings.projectId}</span>#{location?.state?.projectId}
      </Typography>
      {location?.state?.activeStep ?
        null :
        <div className={styles["stepper-container"]}>
          <hr className={styles["top-line-break"]} />
          <MuiStepper
            activeStep={activeStep}
            steps={steps}
            handleStepClick={handleStepClick}
          />
          <hr className={styles["bottom-line-break"]} />
        </div>
      }
      {activeStep === 0
        ? renderConfirmationScreen()
        : renderRateCollabaratorScreen()}
      {activeStep === 1 ?
        <MuiButton
          className={styles["proceed"]}
          disabled={ratingsAndReviews?.length > 1 ? false : true}
          onClick={() => location?.state?.activeStep ? handleRateMembers() : handleProjectEndingButton()}
        >
          {strings.finishProject}
        </MuiButton>
        :
        <MuiButton
          className={styles["proceed"]}
          onClick={() => handleProjectEndingButton()}
        >
          {strings.proceed}
        </MuiButton>
      }
    </Stack>
  );
};

export default ProjectEndingFlow;
